/**
 * Builds a frozen `{ VALUE: 'VALUE' }` lookup object from a readonly tuple of
 * string literals, so every domain enum is available as:
 *   - a tuple (for Zod `z.enum(...)` and iteration),
 *   - a union type,
 *   - an object (`Modality.HYBRID`) for readable call sites.
 */
export function enumObject<const T extends readonly string[]>(
  values: T,
): { readonly [K in T[number]]: K } {
  const obj: Record<string, string> = {};
  for (const v of values) obj[v] = v;
  return Object.freeze(obj) as { readonly [K in T[number]]: K };
}

export function isEnumValue<T extends readonly string[]>(
  values: T,
  candidate: unknown,
): candidate is T[number] {
  return typeof candidate === 'string' && (values as readonly string[]).includes(candidate);
}
